/**
 * Whether a username still looks like the one sign-up generated: "user-" and
 * eight base32 characters, the shape the api's generatedUsername produces.
 *
 * Only ever decides whether to suggest choosing one. Somebody who picked a
 * handle of that shape on purpose sees a suggestion they can ignore.
 */
export function isGeneratedUsername(username: string): boolean {
  return /^user-[a-z2-7]{8}$/.test(username);
}
